export default __webpack_public_path__ + "static/media/Nice-GO-Logo.44bfc31d.svg";